import React from 'react';
import PropTypes from 'prop-types';
import BuildChildren from 'utils/BuildChildren';
import className from 'classnames';
import classes from './CardListC.module.scss';

const CardListC = (props) => {
  const {
    items = [],
    listItemsShown = items.length,
    divided = false,
    containerBorder = true,
    onShowMore,
  } = props;

  const shouldShowMore = items.length > listItemsShown;

  return (
    <div className={classes.container}>
      <div className={containerBorder ? classes.itemsContainer : undefined}>
        {items.map((item, i) => (
          <div
            className={className(
              divided ? classes.itemDivided : classes.item,
              !items.slice(0, listItemsShown).includes(item) && shouldShowMore && classes.hide,
            )}
            key={`${item.type}-item-${i}`}
          >
            {BuildChildren(item)}
          </div>
        ))}
      </div>
      {shouldShowMore &&
        <div className={classes.showMore}>
          <button aria-label='Show More' className={classes.showMoreButton} onClick={() => onShowMore()} type='button'>
            SHOW MORE
            <i className={className('far fa-chevron-down', classes.showMoreIcon)} />
          </button>
        </div>}
    </div>
  );
};

CardListC.propTypes = {
  /**
   * A list of items
  */
  items: PropTypes.array,
  /**
   * How many list items to show before 'Show More' paging
  */
  listItemsShown: PropTypes.number,
  /**
   * Show a divider between items
  */
  divided: PropTypes.bool,
  /**
   * Show a top border on the container
  */
  containerBorder: PropTypes.bool,
  /**
   * Function for 'Show More' paging
  */
  onShowMore: PropTypes.func,
};

export default CardListC;
